import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: {},
}

const pincodeSlice = createSlice({
  name: 'pincode',
  initialState,
  reducers: {
    getLatLongByPincodeRequest: (state, action) => {
      state.loading = true
      state.error = null
      state.success = false
    },
    getLatLongByPincodeSuccess: (state, action) => {
      state.loading = false
      state.success = true
      state.data = action.payload
    },
    getLatLongByPincodeError: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.success = false
      state.data = {}
    },
  },
})

export const {
  getLatLongByPincodeRequest,
  getLatLongByPincodeSuccess,
  getLatLongByPincodeError,
} = pincodeSlice.actions

export default pincodeSlice.reducer
